// add, del, star, bug, edit
import versoes from './versions.json';

export const items = versoes;
export const { versao } = items[0];
